import { ThemeProvider } from "@mui/material/styles";
import "./App.css";
import { Canvas } from "./components/canvas/Canvas";
import { Provider } from "react-redux";
import theme from "./styles/theme";
import { store } from "./store";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LandingPage } from "./components/landing/LandingPage";

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/app" element={<Canvas />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
